import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchPlayerStats } from '@api-service/player-stats';
import type {
  GetPlayerStatsOptions,
  PlayerStatsResponse
} from '@api-service/player-stats';

export type UsePlayerStatsOptions = Omit<GetPlayerStatsOptions, 'cursor'> & {
  enabled?: boolean;
  staleTime?: number;
};

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const usePlayerStats = ({
  enabled = true,
  staleTime = FIVE_MINUTES_IN_MS,
  ...options
}: UsePlayerStatsOptions) =>
  useInfiniteQuery<PlayerStatsResponse, Error>({
    queryKey: [
      'player-stats',
      options.accessToken ? 'auth' : 'anon',
      options.fields,
      options.aggregation,
      options.venue,
      options.season,
      options.minGameweek,
      options.maxGameweek,
      options.position,
      options.teamId,
      options.minPrice,
      options.maxPrice,
      options.minDifficulty,
      options.maxDifficulty,
      options.minMinutes,
      options.hideMinutes,
      options.perMillion,
      options.search,
      options.sortBy,
      options.sortDirection,
      options.limit,
      options.ids
    ],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      fetchPlayerStats({ ...options, cursor: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.meta?.hasMore
        ? lastPage.meta.nextCursor ?? undefined
        : undefined,
    keepPreviousData: true,
    enabled,
    staleTime
  });
